module.exports = __webpack_public_path__ + "static/img/patentleft-3.7960fc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/patentleft-3.png
// module id = K+hU
// module chunks = 0